import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {
    ITraveller,
    IWatabiLightBooking
} from "libraries/interfaces/watabilight/IWatabiLightBooking.interface";
import { Yii } from "libraries/interfaces/Yii";
import {FormControl, FormGroup} from "@angular/forms";
import { ICustomerValue } from "../customer/customer.component";
import { IWatabiLightSectionDetails } from "libraries/interfaces/IWenji";
import {IFieldSpecs} from "../../../../../libraries/module/formbuilder/fields/interfaces/field-specs";

class Wording {
    public readonly title: string = Yii.t('wui-shared-js', 'Référence du dossier');
    public readonly travelFrom: string = Yii.t('wui-shared-js', 'Voyage du');
    public readonly travelTo: string = Yii.t('wui-shared-js', 'au');
    public readonly customer: string = Yii.t('wui-shared-js', 'Client ');
    public readonly traveller: string = Yii.t('wui-shared-js', 'Voyageur');
}

enum ETravellerType {
    ADULT = "Adult",
    CHILD = "Child",
    INFANT = "Infant"
}

enum ETravellerTypeCode {
    ADULT = "ADT",
    CHILD = "CHD",
    INFANT = "INF"
}

@Component({
    selector: 'watabilight-reference',
    templateUrl: './reference.component.html',
    styles: [`
        .data {
            width: 100%;
            display: flex;
        }

        .box {
            flex: 1 1 auto;
        }
        
        .titleInput {
            width:30%;
        }
        
        .icon {
            margin-right: 10px;
        }
    `],
    styleUrls: [
        '../../booking.component.scss'
    ]
})
export class ReferenceComponent implements OnInit, OnChanges {
    @Input()
    public booking: IWatabiLightBooking;
    @Input()
    public customer: FormGroup;
    @Input()
    public sectionConfig: IWatabiLightSectionDetails;
    @Input()
    public isLatestOutputForAgency: boolean;
    @Input()
    public referenceForm: FormGroup;

    public title: string;
    public description: string;

    public isEditing: boolean = false;
    public titleFormConfig: IFieldSpecs = {
        formGroup: null,
        formControlName: "agencyTitle",
        className: "watabiLightInput"
    };

    public wording: Wording = new Wording();
    public resumeCustomer: string = "";
    public resumeTraveller: string = "";

    @Output()
    public onEdit: EventEmitter<number> = new EventEmitter();

    public ngOnInit(): void {
        this.title = this.sectionConfig?.title ? this.sectionConfig?.title : this.wording.title;
        this.description = this.sectionConfig?.description ? this.sectionConfig?.description : "";
        this.referenceForm.addControl("agencyTitle", new FormControl({}));
        this.titleFormConfig.formGroup = this.referenceForm;
        this.titleFormConfig.formGroup.get(this.titleFormConfig.formControlName).patchValue(this.booking?.agencyTitle || this.booking?.introduction?.title)
        this.initResume();
    }


    public updateAgencyTitle(): void {
        this.isEditing = false;
        this.booking.agencyTitle = this.titleFormConfig.formGroup.get(this.titleFormConfig.formControlName).value;
        this.onEdit.emit(3);
    }

    public edit(): void {
        this.isEditing = true;
        this.onEdit.emit(5);
    }

    public update(): void {
        this.initResumeCustomer();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.initResumeCustomer();
    }

    public initResume(): void {
        this.initResumeCustomer();
        this.initResumeTraveller();
    }

    public initResumeCustomer(): void {
        if (this.customer) {
            const customerValue: ICustomerValue = this.customer.value;
            this.resumeCustomer = `${customerValue.title} ${customerValue.lastName} ${customerValue.firstName}`;
        }
    }

    public initResumeTraveller(): void {
        const traveller: ITraveller[] = this.booking.travellers;
        const travellerTable: number[] = [0, 0, 0];
        traveller?.forEach((data: ITraveller) => {
            switch (data.type.code) {
                case ETravellerType.ADULT: {
                    travellerTable[0]++;
                    break;
                }
                case ETravellerType.CHILD: {
                    travellerTable[1]++;
                    break;
                }
                case ETravellerType.INFANT: {
                    travellerTable[2]++;
                    break;
                }
                default:
                    break;
            }
        });
        const adultResume: string = `${travellerTable[0]} ${ETravellerTypeCode.ADULT}`;
        const childResume: string = `${travellerTable[1]} ${ETravellerTypeCode.CHILD}`;
        const infantResume: string = `${travellerTable[2]} ${ETravellerTypeCode.INFANT}`;
        this.resumeTraveller = `${adultResume} - ${childResume} - ${infantResume}`;

    }

}
